<style>
.multiselect__content-wrapper {
  position: relative;
}

.character-option-icon {
  margin: 0 6px 0 0;
  height: 22px;
}

.character-label-icon {
  margin: 0 6px 0 0;
  height: 26px;
}

.map_holder {
  width: 100%;
  height: 450px;
}

.fa-minus-circle {
  color: #e74c3c;
  cursor: pointer;
}
.fa-plus-circle {
  color: #27c24c;
  cursor: pointer;
}

.redes {
  display: inline-block;
  width: calc(100% - 45px);
}
</style>
<template>
  <admin-layout>
    <template v-slot:breadcrumb>
      <ol class="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
        <li class="breadcrumb-item text-sm">
          <a class="opacity-5 text-white" href="javascript:;">Lojista</a>
        </li>
        <li class="breadcrumb-item text-sm text-white" aria-current="page">
          Meu Servico
        </li>
      </ol>
    </template>

    <template v-slot:header>
      <h5 class="font-weight-bolder text-white mt-4 mb-0"></h5>
    </template>

    <template #content>
      <div class="row">
        <div class="col-md-12" v-if="servicoRevisao">
          <div class="card">
            <div class="card-header p-3 pb-0">
              <h6 class="mb-1">Alteração de Serviço</h6>
              <p class="text-sm mb-0">
                Foi solicitado a alteração do serviço:
                {{ servicoRevisao.titulo }} - Aguarde a avaliação de algum
                moderador para alterá-lo novamente.
              </p>
            </div>
            <div class="card-body p-3">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="example-text-input" class="form-control-label"
                    >Título</label
                  >
                  <input
                    :value="servicoRevisao.titulo"
                    class="form-control"
                    type="text"
                    onfocus="focused(this)"
                    disabled
                  />
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="example-text-input" class="form-control-label"
                    >Contato</label
                  >
                  <input
                    :value="servicoRevisao.contato"
                    class="form-control"
                    type="text"
                    onfocus="focused(this)"
                    disabled
                  />
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label for="example-text-input" class="form-control-label"
                    >Endereço</label
                  >
                  <input
                    :value="servicoRevisao.endereco"
                    class="form-control"
                    type="text"
                    onfocus="focused(this)"
                    disabled
                  />
                </div>
              </div>
            </div>
            <div class="card-footer"></div>
          </div>
        </div>

        <div class="col-md-12" v-if="!servicoRevisao">
          <div class="card">
            <form @submit.prevent="checkMode">
              <div class="card-header pb-0">
                <div class="d-flex align-items-center">
                  <p class="mb-0">Serviço</p>
                </div>
              </div>

              <div class="card-body">
                <div class="form-group">
                  <label for="example-text-input" class="form-control-label"
                    >Título</label
                  >
                  <input
                    v-model="form.titulo"
                    class="form-control"
                    type="text"
                    onfocus="focused(this)"
                    onfocusout="defocused(this)"
                    :class="{ 'is-invalid': form.errors.titulo }"
                  />
                </div>
                <div
                  class="invalid-feedback mb-3"
                  :class="{ 'd-block': form.errors.titulo }"
                >
                  {{ form.errors.titulo }}
                </div>

                <div class="col-md-12">
                  <div class="form-group">
                    <label for="example-text-input" class="form-control-label"
                      >Contato</label
                    >
                    <input
                      v-model="form.contato"
                      v-maska="['(##) #-####-####', '(##) ####-####']"
                      class="form-control"
                      type="text"
                      onfocus="focused(this)"
                      onfocusout="defocused(this)"
                      :class="{ 'is-invalid': form.errors.contato }"
                    />
                  </div>
                  <div
                    class="invalid-feedback mb-3"
                    :class="{ 'd-block': form.errors.contato }"
                  >
                    {{ form.errors.contato }}
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="form-group">
                    <label for="example-text-input" class="form-control-label"
                      >Categoria</label
                    >
                    <select
                      id="subcategoria_id"
                      v-model="form.categoria_id"
                      class="form-control"
                      :class="{ 'is-invalid': form.errors.categoria_id }"
                    >
                      <option
                        v-for="(cat, index) in categorias"
                        :key="index"
                        :value="cat.id"
                      >
                        {{ cat.descricao }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="example-text-input" class="form-control-label"
                      >Subcategoria</label
                    >
                    <select
                      id="subcategoria_id"
                      v-model="form.subcategoria_id"
                      class="form-control"
                      :class="{ 'is-invalid': form.errors.subcategoria_id }"
                      required
                    >
                      <option
                        v-for="(cat, index) in filteredItems"
                        :key="index"
                        :value="cat.id"
                      >
                        {{ cat.descricao }}
                      </option>
                    </select>
                  </div>
                  <div
                    class="invalid-feedback mb-3"
                    :class="{ 'd-block': form.errors.subcategoria_id }"
                  >
                    {{ form.errors.subcategoria_id }}
                  </div>
                </div>

                <!-- teste corte de imagem -->
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <a
                        class="btn"
                        v-bind:class="{ disabled: checkbtn }"
                        @click="toggleShow2"
                        >Carregar Imagem</a
                      >

                      <my-upload
                        field="img"
                        @crop-success="cropSuccess"
                        @crop-upload-success="cropUploadSuccess"
                        @crop-upload-fail="cropUploadFail"
                        v-model="show"
                        :width="1280"
                        :height="720"
                        :url="urlBase"
                        :params="params"
                        :headers="headers"
                        :maxSize="5024"
                        :noCircle="true"
                        img-format="png"
                        langType="pt-br"
                      >
                      </my-upload>

                      <br />

                      <div
                        v-if="checkbtn"
                        class="invalid-feedback mb-3"
                        :class="{ 'd-block': checkbtn }"
                      >
                        Você chegou no limite de fotos enviadas
                      </div>

                      <div
                        class="invalid-feedback mb-3"
                        :class="{ 'd-block': form.errors.img }"
                      >
                        {{ form.errors.img }}
                      </div>

                      <ul class="image-list">
                        <li
                          class="list"
                          v-for="(item, index) in imgDataList"
                          :key="index"
                        >
                          <a
                            v-if="imgDataList"
                            class="btn btn-icon btn-2 btn-danger"
                            style="
                              padding: 1px 4px;
                              right: -20px;
                              top: -30px;
                              position: relative;
                            "
                            @click="removerImg(index, item)"
                          >
                            <i class="ni ni-fat-delete"></i>
                          </a>
                          <img
                            v-if="item"
                            :src="
                              '/storage/img/' +
                              setor +
                              '/' +
                              item
                            "
                            width="150"
                            height="100"
                          />
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <!--- teste corte de imagem --->

                <div class="col-md-12">
                  <div class="form-group">
                    <label for="example-text-input" class="form-control-label"
                      >Tags</label
                    >

                    <multiselect
                      v-model="form.tags"
                      placeholder="Selecione as tags do serviço"
                      label="descricao"
                      :option-height="104"
                      :options="options"
                      :multiple="true"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preserve-search="true"
                      track-by="descricao"
                      :preselect-first="false"
                    >
                      <template v-slot:singlelabel="{ value }">
                        <div class="multiselect-single-label">
                          <img
                            class="character-label-icon"
                            :src="value.icone.link_img"
                          />
                          {{ value.descricao }}
                        </div>
                      </template>

                      <template v-slot:option="{ option }">
                        <img
                          class="character-option-icon"
                          :src="option.icone.link_img"
                        />
                        {{ option.descricao }}
                      </template>
                    </multiselect>
                  </div>
                  <div
                    class="invalid-feedback mb-3"
                    :class="{ 'd-block': form.errors.tags }"
                  >
                    {{ form.errors.tags }}
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="map_holder">
                    <place-search
                      v-bind:ready="ready"
                      placeholder="Digite o endereço"
                      loading="Map is loading"
                      v-bind:gps_timeout="7000"
                      v-bind:fallbackProcedure="fallbackProcedure"
                      v-bind:zoom="zoom"
                      v-bind:geolocation="geolocation"
                      v-bind:address="address"
                      v-bind:manually="manually"
                      v-bind:verConsole="verConsole"
                      v-bind:query_mod="query_mod"
                      @changed="getMapData"
                    >
                    </place-search>
                  </div>
                </div>
                <div
                  class="invalid-feedback mb-3"
                  :class="{ 'd-block': form.errors.endereco }"
                >
                  {{ form.errors.endereco }}
                </div>
                <hr class="mt-3" />
                <div class="col-md-12">
                  <label for="example-text-input" class="h5"
                    >Mídias Sociais</label
                  >

                  <div
                    class="form-group"
                    v-for="(input, k) in form.redes"
                    :key="k"
                  >
                    <div class="row">
                      <div class="col-4">
                        <label
                          for="example-text-input"
                          class="form-control-label"
                          >Mídia Social</label
                        >
                        <select
                          v-model="input.rede_id"
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors[`redes.${k}.rede_id`],
                          }"
                        >
                          <option
                            v-for="(rede, index) in redes"
                            :key="index"
                            :value="rede.id"
                          >
                            {{ rede.descricao }}
                          </option>
                        </select>
                        <div
                          class="invalid-feedback mb-3"
                          :class="{
                            'd-block': form.errors[`redes.${k}.rede_id`],
                          }"
                        >
                          {{ form.errors[`redes.${k}.rede_id`] }}
                        </div>
                      </div>
                      <div class="col-5">
                        <label
                          for="example-text-input"
                          class="form-control-label"
                          >Link</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          v-model="input.link"
                          :class="{
                            'is-invalid': form.errors[`redes.${k}.link`],
                          }"
                        />

                        <div
                          class="invalid-feedback mb-3"
                          :class="{
                            'd-block': form.errors[`redes.${k}.link`],
                          }"
                        >
                          {{ form.errors[`redes.${k}.link`] }}
                        </div>
                      </div>

                      <div class="col-3 mt-4 pt-3">
                        <span>
                          <i
                            class="fas fa-minus-circle"
                            @click="remove(k)"
                            v-show="k || (!k && form.redes.length > 1)"
                          ></i>
                          <i
                            class="mx-1 fas fa-plus-circle"
                            @click="add(k)"
                            v-show="k == form.redes.length - 1"
                          ></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="form-group">
                    <label for="example-text-input" class="form-control-label"
                      >Descrição</label
                    >
                    <textarea
                      v-model="form.descricao"
                      class="form-control"
                      onfocus="focused(this)"
                      onfocusout="defocused(this)"
                      :class="{ 'is-invalid': form.errors.descricao }"
                      rows="4"
                    >
                    </textarea>
                  </div>
                  <div
                    class="invalid-feedback mb-3"
                    :class="{ 'd-block': form.errors.descricao }"
                  >
                    {{ form.errors.descricao }}
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <button
                  :disabled="form.processing"
                  type="submit"
                  class="btn btn-primary"
                >
                  {{ buttonTxt }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </template>
  </admin-layout>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";
import myUpload from "vue-image-crop-upload";

export default {
  props: [
    "servico",
    "user",
    "subcategorias",
    "tags",
    "redes",
    "servicoRevisao",
    "prefeitura_url",
    "setor",
    "categorias",
  ],
  components: {
    "my-upload": myUpload,
    AdminLayout,
  },

  data() {
    return {
      modal: Object,

      verConsole: false,
      show: false,
      t_lat: "",
      t_lng: "",
      query_mod: "",

      urlBase:
        "/admin/galeria/uploadimg/" + this.setor,
      arquivo_nome: "",
      params: {
        setor: this.setor,
      },
      headers: {
        smail: "*_~",
      },
      imgDataUrl: "",
      imgDataList: this.servico.img ?? [],

      options: this.tags,
      servico_revisao: this.servicoRevisao,

      form: this.$inertia.form(
        {
          id: this.servico.id,
          titulo: this.servico.titulo,
          contato: this.servico.contato,
          descricao: this.servico.descricao,
          img: this.servico.img,
          subcategoria_id: this.servico.subcategoria_id,
          tags: this.servico.tags,
          latitude: this.servico.latitude,
          longitude: this.servico.longitude,
          endereco: this.servico.endereco,
          redes: [{}],
          categoria_id: "",

          uuid: this.servico.uuid,
        } /* ,
        { resetOnSuccess: false } */
      ),

      ready: true, //Add ready:false to stop map from loading, and then when changed to true map will auto load
      fallbackProcedure: "address", //gps | geolocation | address | manually
      zoom: 10, //Default Zoom
      geolocation: {
        // If GPS and Find by address fails then, map will be positioned by a default geolocation
        lat: 31.73858,
        lng: -35.98628,
        zoom: 2,
      },
      address: {
        query: "Brazil", //If GPS fails, Find by address is triggered
        zoom: 19, //Default Zoom
        lat: -23.5505,
        lng: -46.6333,
      },
      manually: {
        address_description: "",
        city: "",
        country: "",
        lat: -22.9597,
        lng: -44.0411,
        state: "",
        zip_code: "",
        zoom: 13,
      },
      place: {},
      form_data: {},
    };
  },

  computed: {
    checkMode() {
      return this.servico.id ? this.update : this.create;
      
    },

    buttonTxt() {
      return this.servico.id ? "Editar" : "Salvar";
    },
    checkbtn() {
      if (this.imgDataList.length >= 6) {
        return true;
      } else {
        return false;
      }
    },    

    filteredItems: function () {
      return this.subcategorias.filter(function (el) {
        return el.categoria_id === this.form.categoria_id;
      }, this);
    },
  },

  methods: {
    

    mudarMap($lat, $lng, $zoom = 17, $end = ""){    
      this.geolocation = {
        lat: $lat,
        lng: $lng,
        zoom: $zoom,
      };
      this.fallbackProcedure = "geolocation";
      this.ready = true;
      this.query_mod = $end;
      if(this.verConsole){        
        console.log("Lat: "+$lat);
        console.log("Lng: "+$lng);
      }
    },

    mudarEnd(end, zoom = 15, lat = 0, lng = 0) {    
      this.address = {
        query: end,
        zoom: zoom,
        lat: lat,
        lng: lng,
      },
      this.fallbackProcedure = "address";  
      
      if(this.verConsole){        
        console.log("Endereço: "+this.endereco);
      }

      // setTimeout(() => this.ready = false, 500);        
      // setTimeout(() => this.ready = true, 500);      
      
    },

    //INICIO - Corte de Imagem
    toggleShow2() {
      this.show = !this.show;
    },

    removerImg(index, item) {
      this.imgDataList.splice(index, 1);
      console.log(this.imgDataList);
      axios.post("/admin/galeria/removerimg", { file: item });
    },

    cropSuccess(imgDataUrl, field) {
      console.log("-------- crop success --------");
      this.imgDataUrl = imgDataUrl;
    },

    cropUploadSuccess(jsonData, field) {
      this.imgDataList.push(this.prefeitura_url+"/"+jsonData.file);
      console.log("-------- upload success --------");
      console.log(jsonData);
      console.log("Arquivo: " + jsonData.file);
      console.log("Arquivo List: " + this.imgDataList);
      console.log("field: " + field);
      console.log("----------------- FORMULÁRIO -------------------");
      console.log(this.form);
    },

    cropUploadFail(status, field) {
      console.log("-------- upload fail --------");
      console.log(status);
      console.log("field: " + field);
    },
    //FIM - Corte de Imagem

    update() {
      this.form.img = this.imgDataList;      
      this.form.post(
        this.route("admin.lojistas.servico.store", this.form),
        {
          preserveScroll: true,
          onSuccess: () => {
            this.form.reset();
          },
        },
        {
          replace: true,
        }
      );
    },

    create() {

      
      
      this.form.img = this.imgDataList;
      this.form.post(
        this.route("admin.lojistas.servico.store", this.form),
        {
          preserveScroll: true,
          onSuccess: () => {
            /* this.closeModal(); */
            this.form.reset();
          },
        } /* ,
        {
          resetOnSuccess: false,
        } */
      );
    },

    getMapData(place) {
      this.place = place;
      // console.log(place);
      this.form.latitude = place.lat;
      this.form.longitude = place.lng;
      this.form.endereco = place.address_description;
    },
    triggerReady() {
      this.fallbackProcedure = "manually";
      this.ready = true;
    },

    add() {
      this.form.redes.push({
        rede_id: "",
        link: "",
      });
    },

    remove(k) {
      this.form.redes.splice(k, 1);
    },
  },

  created() {
    if(this.servico.endereco){
      this.mudarEnd(this.servico.endereco);
    }else{
      this.mudarEnd('Brasil', 3)
    }
    
  },

  watch: {
    query_mod: function (val) {
      console.log("query_mod: " + val);
    },
  },  

  mounted() {
    console.log(this.servico);
    if (this.servico.id) {
      this.form.categoria_id = this.servico.subcategoria.categoria_id;
      let redes = this.servico.redes.map((item) => {
        return item.pivot;
      });

      this.form.redes = redes;      
      
    }    
  },
};
</script>


<style>
li.list {
  float: left;
  padding: 5px;
}
ul.image-list {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
</style>
